
import React from 'react';
import { Button } from '@/components/ui/button';
import { Users, ArrowLeft } from 'lucide-react';

interface TeacherProfilesPageHeaderProps {
  onBackToAdmin: () => void;
}

export const TeacherProfilesPageHeader: React.FC<TeacherProfilesPageHeaderProps> = ({
  onBackToAdmin,
}) => {
  return (
    <div className="flex items-center gap-4">
      <Button
        variant="outline"
        size="sm"
        onClick={onBackToAdmin}
        className="flex items-center gap-2"
      >
        <ArrowLeft className="h-4 w-4" />
        กลับ
      </Button>
      <div className="flex items-center gap-3">
        <div className="p-2 bg-blue-100 rounded-lg">
          <Users className="h-6 w-6 text-blue-600" />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-gray-900">รายชื่อครู</h1>
          <p className="text-gray-600">จัดการและดูข้อมูลครูทั้งหมด</p>
        </div>
      </div>
    </div>
  );
};
